import { useCookie } from 'react-use';

import loggerHelper from 'utils/logger/loggerHelper';

export const APPLICATION_STATS_COOKIE = 'application_stats';

export function useApplicationStats(
  overrideCookieName = APPLICATION_STATS_COOKIE
) {
  const [cookieValue, updateCookie, deleteCookie] =
    useCookie(overrideCookieName);

  function updateApplicationStats(statKey, value) {
    if (!value) {
      return;
    }
    const applicationStats = getCookies();

    if (
      !(statKey in applicationStats) ||
      !Array.isArray(applicationStats?.[statKey])
    ) {
      applicationStats[statKey] = [];
    }

    const newCookieValue = {
      ...applicationStats,
      [statKey]: [...applicationStats[statKey], value],
    };
    updateCookie(JSON.stringify(newCookieValue));
  }

  function getCookies() {
    let applicationStats = {};
    try {
      applicationStats = JSON.parse(cookieValue) || {};
    } catch (e) {
      loggerHelper({
        message: 'Error parsing the application stats cookie',
        info: e,
      });
    }

    return applicationStats;
  }

  return [getCookies, updateApplicationStats, updateCookie, deleteCookie];
}
